{
  "conversations": {
    "conversationsApp": "Konversationsapp",
    "locationId": "Plats-ID",
    "idToken": "ID-token",
    "conversationRoutes": "Konversationsrutter",
    "conversationProviders": "Konversationsleverantörer",
    "viewTheListOfConversation": "Visa Lista av-konversationen Anpassad-leverantörer har lagts till på Kontot här.",
    "logo": "Logotyp",
    "name": "Namn",
    "alias": "Alias",
    "type": "Typ"
  }
}
